import { JsonProperty, Serializable } from "@anna-money/anna-web-lib/serializerOld";
import { AddressData } from "services/address/addressTypes";

@Serializable()
export class CompanyBusinessActivityData {
  constructor(
    @JsonProperty() readonly businessActivityId: string,
    @JsonProperty() readonly companyActivityId: string,
    @JsonProperty() readonly code: string,
    @JsonProperty() readonly description: string,
    @JsonProperty({ required: false, type: String }) readonly industryCode: Nullable<string>,
    @JsonProperty({ required: false, type: String }) readonly addressId: Nullable<string>,
    @JsonProperty({ required: false, type: AddressData }) readonly address: Nullable<AddressData>,
  ) {}
}

@Serializable()
export class CompanyBusinessActivitiesData {
  constructor(
    @JsonProperty({ type: CompanyBusinessActivityData, isArray: true })
    readonly businessActivities: CompanyBusinessActivityData[],
  ) {}
}

@Serializable()
export class CompanyBusinessActivityCreateData {
  constructor(@JsonProperty() readonly businessActivityId: string) {}
}

@Serializable()
export class CompanyBusinessActivityDeleteData {
  constructor(@JsonProperty() readonly businessActivityId: string) {}
}
